import { createUseStyles } from "react-jss"
import Card from "../components/Card"
import Button from "../components/Button"
import FullScreenLoadingIndicator from "../components/FullScreenLoadingIndicator"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import useAgiAdjustmentActions from "../hooks/useAgiAdjustmentActions"
import { useAppDispatch, useAppSelector } from "../redux/hooks"
import { useEffect } from "react"
import AgiAdjustmentPeriodList from "../components/AgiAdjustment/AgiAdjustmentPeriodList"
import { pageIndexChanged } from "../redux/slices/agiAdjustmentSlice"

const AgiAdjustments = () => {
    const styles = useStyles()
    const navigate = useNavigate()
    const { t } = useTranslation('agiAdjustment');
    const { getPeriods } = useAgiAdjustmentActions()
    const dispatch = useAppDispatch()

    const loading = useAppSelector(state => state.agiAdjustment.loading)
    const periods = useAppSelector(state => state.agiAdjustment.periods)
    const currentPeriod = useAppSelector(state => state.agiAdjustment.currentPeriod)
    const isCurrentPeriodAdjusted = useAppSelector(state => state.agiAdjustment.isCurrentPeriodAdjusted)
    const pageIndex = useAppSelector(state => state.agiAdjustment.pageIndex)
    const pageSize = useAppSelector(state => state.agiAdjustment.pageSize)

    useEffect(() => {
        getPeriods()
    }, [])

    const onPageChange = (pageIndex: number) => {
        dispatch(pageIndexChanged(pageIndex))
    }

    const renderAdjustAgiFilesButton = () => {
        return (
            <div className={styles.buttonContainer}>
                <Button
                    onClick={() => navigate('/agiAdjustment/create')}
                    title={t('adjustAgi')}
                    className={styles.button}
                />
            </div>
        )
    }

    return (
        <>
        <Card className={styles.card}>
            <h2>
                {t('title')}
            </h2>
        </Card>
        {!isCurrentPeriodAdjusted &&
        <Card className={`${styles.card} ${styles.adjustmentDueContainer}`}>
            <div>
                {t('adjustmentDue', {currentPeriod: currentPeriod})}
            </div>
            {renderAdjustAgiFilesButton()}
        </Card>
        }
        <Card>
            {isCurrentPeriodAdjusted &&
                renderAdjustAgiFilesButton()
            }
            {periods &&
            <AgiAdjustmentPeriodList
                periods={periods}
                pageIndex={pageIndex}
                pageSize={pageSize}
                onPageChange={onPageChange}
                onRowClick={(period) => {navigate('/agiAdjustment/' + period)}}
            />}
            <FullScreenLoadingIndicator visible={loading} />
        </Card>
        </>
    )
}

export default AgiAdjustments

const useStyles = createUseStyles({
    card: {
        marginBottom: 20
    },
    adjustmentDueContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    info: {
        marginTop: 20,
    },
    buttonContainer: {
        display: 'flex',
        flex: 1,
        width: '100%',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: 10
    },
    button: {
        alignSelf: 'flex-end'
    }
})
